var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDuplicate = function SvgDuplicate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.668.667H7.335c-.92 0-1.667.747-1.667 1.666v3.334H2.335c-.92 0-1.667.747-1.667 1.666v8.334c0 .919.747 1.666 1.667 1.666h8.333c.92 0 1.667-.747 1.667-1.666v-3.334h3.333c.92 0 1.667-.747 1.667-1.666V2.333c0-.919-.748-1.666-1.667-1.666m-13.333 15V7.333h8.333l.002 8.334zm13.333-5h-3.333V7.333c0-.919-.748-1.666-1.667-1.666H7.335V2.333h8.333z"
  })));
};
export default SvgDuplicate;